import request from '@/utils/request'
import axios from 'axios'
/**
 * @description 上传
 * @param {Object} param data {Object} 传值参数
 */
export function getOssConfig (configId) {
  return request({
    url: '/common/get-oss-signature',
    method: 'get'
  })
}
export function ossUpload(file) {
  // return axios.post(url).then(function (response) {
  //   return response.data.signature;
  // })
  console.log('file')
  console.log(file)
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };
  var formData = new FormData();
  formData.append('file', file);
  return axios.post(process.env.VUE_APP_BASE_API +  '/common/oss/uploadFile',formData,config).then(function (res) {
    return res.data;
  })
};